var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 45,
    viewBox: "0 0 46 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 22.5,
    r: 22.5,
    fill: "url(#paint0_linear_16959_2867)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16959_2867)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1567 22.5L20.188 29.5313L34.2505 15.4688",
    stroke: "white",
    strokeWidth: 4.21875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16959_2867",
    x1: 23,
    y1: 0,
    x2: 23,
    y2: 45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04608A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00245A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16959_2867"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.75,
    height: 33.75,
    fill: "white",
    transform: "translate(6.12524 5.62512)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check_circle.637a91d9d8380cb5fade97305750546d.svg";
export { ForwardRef as ReactComponent };